module.exports = __webpack_public_path__ + "img/Bathroom.65ccb30f.jpg";